/**
 * @generated SignedSource<<689601e2d22b574e0e4711e6c6d0dc01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateClientPortalConfigInput = {
  clientOrgId: string;
  clientName?: string | null;
  portalActive?: boolean | null;
  accountManagerId?: string | null;
  portalPrimaryColour?: string | null;
  portalSenderName?: string | null;
  showInvoices?: boolean | null;
  allowFileUpload?: boolean | null;
  hideTimeEntries?: boolean | null;
  hideEstimates?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateClientPortalConfigMutation$variables = {
  input: UpdateClientPortalConfigInput;
};
export type updateClientPortalConfigMutation$data = {
  readonly updateClientPortalConfig: {
    readonly clientPortalConfig: {
      readonly portalActive: boolean | null;
      readonly portalLogoUrl: string | null;
      readonly portalPrimaryColour: string | null;
      readonly portalSenderName: string | null;
      readonly showInvoices: boolean | null;
      readonly allowFileUpload: boolean | null;
      readonly hideTimeEntries: boolean | null;
      readonly hideEstimates: boolean | null;
    } | null;
  } | null;
};
export type updateClientPortalConfigMutation = {
  variables: updateClientPortalConfigMutation$variables;
  response: updateClientPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateClientPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateClientPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientPortalConfig",
        "kind": "LinkedField",
        "name": "clientPortalConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalLogoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalPrimaryColour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalSenderName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showInvoices",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowFileUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hideTimeEntries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hideEstimates",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateClientPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateClientPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "71f8fb14eb4351ca2c1b2aae2f9d63a3",
    "id": null,
    "metadata": {},
    "name": "updateClientPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateClientPortalConfigMutation(\n  $input: UpdateClientPortalConfigInput!\n) {\n  updateClientPortalConfig(input: $input) {\n    clientPortalConfig {\n      portalActive\n      portalLogoUrl\n      portalPrimaryColour\n      portalSenderName\n      showInvoices\n      allowFileUpload\n      hideTimeEntries\n      hideEstimates\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca926b6a01186795014e46c6a28b8d5d";

export default node;
